import { logger } from '@utils';
import { SagaIterator } from 'redux-saga';
import * as CallsWebsocket from './calls.websocket';

export function* newCall(action: any): SagaIterator {
  try {
    CallsWebsocket.newCall(action.payload);
  } catch (error) {
    logger.info(error);
  }
} 

export function* callAction(action: any): SagaIterator {
  try {
    CallsWebsocket.callResponse(action.payload);
  } catch (error) {
    logger.info(error);
  }
} 

export function* callHistory(action: any): SagaIterator {
  try {
    CallsWebsocket.callHistory(action.payload);
  } catch (error) {
    logger.info(error);
  }
} 

export function* allowCalls(action: any): SagaIterator {
  try {
    CallsWebsocket.allowCalls(action.payload);
  } catch (error) {
    logger.info(error);
  }
} 


// WEBPACK FOOTER //
// ./src/services/calls/calls.saga.ts